// Petra Fina: mobile conversion UX helpers for product and collection pages.
(function () {
  if (window.__petraMobileConversionUx) return;
  window.__petraMobileConversionUx = true;

  var STYLE_ID = 'petra-mobile-conversion-ux-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'body.template-product .petra-product-trust {',
      '  display: grid;',
      '  grid-template-columns: repeat(2, minmax(0, 1fr));',
      '  gap: 12px 14px;',
      '  margin: 16px 0 22px;',
      '  padding: 16px;',
      '  border: 1px solid #e7e0dc;',
      '  background: #fbf8f6;',
      '}',
      'body.template-product .petra-product-trust__title {',
      '  grid-column: 1 / -1;',
      '  color: #1f1b1d;',
      '  font-size: 13px;',
      '  font-weight: 600;',
      '  text-transform: uppercase;',
      '  letter-spacing: .05em;',
      '}',
      'body.template-product .petra-product-trust__item {',
      '  min-width: 0;',
      '  color: #4c4447;',
      '  font-size: 12px;',
      '  line-height: 1.45;',
      '}',
      'body.template-product .petra-product-trust__item strong {',
      '  display: block;',
      '  margin-bottom: 3px;',
      '  color: #1f1b1d;',
      '  font-size: 12px;',
      '  text-transform: uppercase;',
      '  letter-spacing: .03em;',
      '}',
      'body.template-product .petra-product-trust__links {',
      '  display: flex;',
      '  flex-wrap: wrap;',
      '  gap: 4px 8px;',
      '}',
      'body.template-product .petra-product-trust__links a {',
      '  color: #1f1b1d;',
      '  font-weight: 600;',
      '  text-decoration: underline;',
      '  text-underline-offset: 2px;',
      '}',
      '@media (max-width: 767px) {',
      '  body.template-product .petra-product-trust {',
      '    display: grid;',
      '    grid-template-columns: repeat(2, minmax(0, 1fr));',
      '    gap: 8px;',
      '    margin: 12px 0 18px;',
      '    padding: 12px;',
      '    border: 1px solid #e7e0dc;',
      '    background: #fbf8f6;',
      '  }',
      '  body.template-product .petra-product-trust__title {',
      '    grid-column: 1 / -1;',
      '    margin-bottom: 2px;',
      '    color: #1f1b1d;',
      '    font-size: 13px;',
      '    font-weight: 600;',
      '    text-transform: uppercase;',
      '    letter-spacing: .04em;',
      '  }',
      '  body.template-product .petra-product-trust__item {',
      '    min-width: 0;',
      '    font-size: 12px;',
      '    line-height: 1.35;',
      '    color: #4c4447;',
      '  }',
      '  body.template-product .petra-product-trust__item strong {',
      '    display: block;',
      '    margin-bottom: 2px;',
      '    color: #1f1b1d;',
      '    font-size: 12px;',
      '    text-transform: uppercase;',
      '    letter-spacing: .03em;',
      '  }',
      '  body.template-product .petra-product-shipping {',
      '    margin: 0 !important;',
      '    padding: 0 !important;',
      '    border: 0 !important;',
      '  }',
      '  body.template-product .petra-shipping-accordion {',
      '    margin: 0 0 16px;',
      '    border-top: 1px solid #e6dfdb;',
      '    border-bottom: 1px solid #e6dfdb;',
      '  }',
      '  body.template-product .petra-shipping-accordion summary {',
      '    display: flex;',
      '    align-items: center;',
      '    justify-content: space-between;',
      '    min-height: 50px;',
      '    list-style: none;',
      '    color: #2b2628;',
      '    font-size: 13px;',
      '    font-weight: 600;',
      '    text-transform: uppercase;',
      '    letter-spacing: .12em;',
      '  }',
      '  body.template-product .petra-shipping-accordion summary::-webkit-details-marker {',
      '    display: none;',
      '  }',
      '  body.template-product .petra-shipping-accordion summary::after {',
      '    content: "+";',
      '    font-size: 20px;',
      '    line-height: 1;',
      '    font-weight: 300;',
      '  }',
      '  body.template-product .petra-shipping-accordion[open] summary::after {',
      '    content: "-";',
      '  }',
      '  body.template-product .petra-shipping-accordion__content {',
      '    padding: 0 0 16px;',
      '  }',
      '  body.template-product .petra-shipping-accordion__content .petra-product-shipping > h1:first-child,',
      '  body.template-product .petra-shipping-accordion__content .petra-product-shipping > h2:first-child,',
      '  body.template-product .petra-shipping-accordion__content .petra-product-shipping > h3:first-child,',
      '  body.template-product .petra-shipping-accordion__content .petra-product-shipping > h4:first-child,',
      '  body.template-product .petra-shipping-accordion__content .petra-product-shipping > .petra-product-shipping__title:first-child,',
      '  body.template-product .petra-shipping-accordion__content .petra-product-shipping > .petra-product-shipping__label:first-child {',
      '    display: none !important;',
      '  }',
      '  body.template-product .product-page__tabs,',
      '  body.template-product .product-tabs,',
      '  body.template-product .tabs,',
      '  body.template-product .tabs__body,',
      '  body.template-product .tabs__content {',
      '    height: auto !important;',
      '    max-height: none !important;',
      '    overflow: visible !important;',
      '  }',
      '  html,',
      '  body {',
      '    overflow-x: hidden !important;',
      '  }',
      '  body.template-product,',
      '  body.template-product .page,',
      '  body.template-product main,',
      '  body.template-product .container,',
      '  body.template-product .product-page,',
      '  body.template-product .product-page__container,',
      '  body.template-product .product-page__tabs,',
      '  body.template-product .tabs,',
      '  body.template-product .tabs__body,',
      '  body.template-product .tabs__content,',
      '  body.template-product .rte {',
      '    max-width: 100% !important;',
      '    box-sizing: border-box;',
      '    overflow-x: hidden !important;',
      '  }',
      '  body.template-product .tabs__content,',
      '  body.template-product .rte,',
      '  body.template-product .rte * {',
      '    overflow-wrap: anywhere;',
      '    word-break: break-word;',
      '  }',
      '  body.template-product .rte img,',
      '  body.template-product .rte iframe,',
      '  body.template-product .rte table,',
      '  body.template-product .tabs__content img,',
      '  body.template-product .tabs__content iframe,',
      '  body.template-product .tabs__content table {',
      '    max-width: 100% !important;',
      '  }',
      '  body.template-product .tabs__content.rte {',
      '    padding-bottom: 36px;',
      '  }',
      '  body.template-product .product-footbar,',
      '  body.template-product .footbar,',
      '  body.template-product [data-js-product-footbar],',
      '  body.template-product .js-product-footbar {',
      '    display: none !important;',
      '  }',
      '  body.template-product .product-page-info__button-add-to-cart .btn,',
      '  body.template-product [data-js-product-button-add-to-cart] {',
      '    min-height: 48px;',
      '    font-size: 14px;',
      '    letter-spacing: .04em;',
      '  }',
      '  body.template-collection .product-collection__content,',
      '  body.template-product .product-collection__content {',
      '    gap: 3px;',
      '  }',
      '  body.template-collection .product-options,',
      '  body.template-search .product-options,',
      '  body.template-product .product-collection .product-options {',
      '    max-height: 34px;',
      '    overflow: hidden;',
      '    position: relative;',
      '    margin-bottom: 6px !important;',
      '  }',
      '  body.template-collection .product-options::after,',
      '  body.template-search .product-options::after,',
      '  body.template-product .product-collection .product-options::after {',
      '    content: "";',
      '    position: absolute;',
      '    left: 0;',
      '    right: 0;',
      '    bottom: 0;',
      '    height: 16px;',
      '    background: linear-gradient(to bottom, rgba(255,255,255,0), #fff);',
      '    pointer-events: none;',
      '  }',
      '  body.template-collection .product-collection__title,',
      '  body.template-search .product-collection__title,',
      '  body.template-product .product-collection__title {',
      '    min-height: 38px;',
      '    line-height: 1.25;',
      '  }',
      '  body.template-collection .product-collection__button-add-to-cart .btn,',
      '  body.template-search .product-collection__button-add-to-cart .btn,',
      '  body.template-product .product-collection__button-add-to-cart .btn {',
      '    min-height: 40px;',
      '    padding-left: 6px;',
      '    padding-right: 6px;',
      '    font-size: 11px;',
      '    line-height: 1.1;',
      '    letter-spacing: .02em;',
      '  }',
      '  body.template-collection .product-collection__reviews,',
      '  body.template-search .product-collection__reviews,',
      '  body.template-product .product-collection__reviews {',
      '    margin-top: 6px !important;',
      '  }',
      '  body.template-product .product-collection .product-options__value,',
      '  body.template-product .product-collection .product-options__value--circle,',
      '  body.template-product .product-collection .product-options__value--large-text,',
      '  body.template-product .product-collection .product-options__value--square {',
      '    width: 22px !important;',
      '    height: 22px !important;',
      '    min-width: 22px !important;',
      '    min-height: 22px !important;',
      '    margin: 0 3px 4px 0 !important;',
      '    font-size: 11px !important;',
      '  }',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function makeTrustBlock() {
    var block = document.createElement('div');
    block.className = 'petra-product-trust';
    block.setAttribute('aria-label', 'Informacoes de compra segura');
    block.innerHTML = [
      '<div class="petra-product-trust__title">Compra segura</div>',
      '<div class="petra-product-trust__item"><strong>Frete no produto</strong>Calcule prazo e valor pelo CEP.</div>',
      '<div class="petra-product-trust__item"><strong>Tamanho seguro</strong>Confira medidas e provador virtual.</div>',
      '<div class="petra-product-trust__item"><strong>Loja f&iacute;sica</strong>Atendimento no Bom Retiro, S&atilde;o Paulo.</div>',
      '<div class="petra-product-trust__item"><strong>Atendimento</strong><span class="petra-product-trust__links"><a href="https://wa.me/5511971698885" target="_blank" rel="noopener">WhatsApp</a><a href="https://www.instagram.com/petrafinaloja/" target="_blank" rel="noopener">Instagram</a></span></div>',
    ].join('');
    return block;
  }

  function insertProductTrust() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    if (document.querySelector('.petra-product-trust')) return;

    var buttonWrap = document.querySelector('.product-page-info__button-add-to-cart');
    if (!buttonWrap) {
      var button = document.querySelector('[data-js-product-button-add-to-cart]');
      buttonWrap = button && button.closest('div');
    }
    if (!buttonWrap || !buttonWrap.parentNode) return;

    buttonWrap.parentNode.insertBefore(makeTrustBlock(), buttonWrap.nextSibling);
  }

  function setProductBuyButtonText() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    var selectors = [
      '.product-page-info [data-js-product-button-add-to-cart] .btn__text',
      '.product-page-info__button-add-to-cart .btn__text',
      '.product-page-info [data-js-product-button-add-to-cart]',
    ];
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        var text = (node.textContent || '').trim().toUpperCase();
        if (!text || text.indexOf('ADICIONAR') === -1 || text.indexOf('CARRINHO') === -1) return;
        node.textContent = 'COMPRAR';
      });
    });
  }

  function isMobileProduct() {
    return document.body &&
      document.body.classList.contains('template-product') &&
      window.matchMedia('(max-width: 767px)').matches;
  }

  function getProductButtonWrap() {
    var buttonWrap = document.querySelector('.product-page-info__button-add-to-cart');
    if (!buttonWrap) {
      var button = document.querySelector('[data-js-product-button-add-to-cart]');
      buttonWrap = button && button.closest('div');
    }
    return buttonWrap;
  }

  function compactShippingOnMobile() {
    if (!isMobileProduct()) return;
    if (document.querySelector('.petra-shipping-accordion')) return;

    var shipping = document.querySelector('.petra-product-shipping');
    if (!shipping || !shipping.parentNode) return;

    var details = document.createElement('details');
    details.className = 'petra-shipping-accordion';
    details.innerHTML = [
      '<summary>Calcule o frete</summary>',
      '<div class="petra-shipping-accordion__content"></div>',
    ].join('');

    var content = details.querySelector('.petra-shipping-accordion__content');
    shipping.parentNode.insertBefore(details, shipping);
    content.appendChild(shipping);

    var anchor = document.querySelector('.petra-product-trust') || getProductButtonWrap();
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(details, anchor.nextSibling);
    }
  }

  function init() {
    injectStyle();
    insertProductTrust();
    setProductBuyButtonText();
    compactShippingOnMobile();
    setTimeout(insertProductTrust, 1000);
    setTimeout(setProductBuyButtonText, 1000);
    setTimeout(compactShippingOnMobile, 1000);
    setTimeout(insertProductTrust, 3000);
    setTimeout(setProductBuyButtonText, 3000);
    setTimeout(compactShippingOnMobile, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
